import { defineStore } from "pinia";
import { ref, watch } from "vue";

export const useTabStore = defineStore("tabStore", () => {
  const tabs = ref([]);
  const activePath = ref("");

  function addTab(tab) {
    if (!tabs.value.some((t) => t.path === tab.path)) {
      tabs.value.push(tab);
    }
    activePath.value = tab.path;
  }

  function setActiveTab(path) {
    activePath.value = path;
  }

  function removeTab(path) {
    tabs.value = tabs.value.filter((t) => t.path !== path);
    if (activePath.value === path && tabs.value.length > 0) {
      activePath.value = tabs.value[tabs.value.length - 1].path;
    }
  }

  // 상태 변화 감지용 watch
  watch(tabs, (newVal, oldVal) => {
    // console.log(
    //   "[TabStore] tabs 변경 감지:",
    //   newVal.map((t) => t.path)
    // );
  });

  watch(activePath, (newVal, oldVal) => {
    // console.log(`[TabStore] activePath 변경: '${oldVal}' → '${newVal}'`);
  });

  return {
    tabs,
    activePath,
    addTab,
    setActiveTab,
    removeTab,
  };
});
